import { render, staticRenderFns } from "./FilesFieldtype.vue?vue&type=template&id=0d7b5c78&"
import script from "./FilesFieldtype.vue?vue&type=script&lang=js&"
export * from "./FilesFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports